import {
    ApproveLoteRequest,
    BundleAssignmentDashboard,
    CreateLoteRequest,
    SubmitRevisionRequest,
} from "../../interfaces";
import { BundleAssignmentRepository } from "../repositories";

export class BundleAssignmentProcess {
    private repository: BundleAssignmentRepository;

    constructor() {
        this.repository = new BundleAssignmentRepository();
    }

    async getDashboard(): Promise<BundleAssignmentDashboard> {
        const response = await this.repository.getDashboard();
        return response.data;
    }

    async createLote(payload: CreateLoteRequest): Promise<BundleAssignmentDashboard> {
        const response = await this.repository.createLote(payload);
        return response.data;
    }

    async submitRevision(
        loteId: string,
        payload: SubmitRevisionRequest
    ): Promise<BundleAssignmentDashboard> {
        const response = await this.repository.submitRevision(loteId, payload);
        return response.data;
    }

    async approveLote(
        loteId: string,
        payload: ApproveLoteRequest
    ): Promise<BundleAssignmentDashboard> {
        const response = await this.repository.approveLote(loteId, payload);
        return response.data;
    }
}
